module.exports = __webpack_public_path__ + "static/img/3bac.03c7bf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/3bac.jpg
// module id = vtzj
// module chunks = 1